export default __webpack_public_path__ + "static/media/listItem3.a9996534.svg";